import { render, staticRenderFns } from "./LoginEnterPhoneNumber.vue?vue&type=template&id=15227522&scoped=true&"
import script from "./LoginEnterPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./LoginEnterPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./LoginEnterPhoneNumber.vue?vue&type=style&index=0&id=15227522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15227522",
  null
  
)

export default component.exports